import { render, staticRenderFns } from "./AboutProgram.vue?vue&type=template&id=1f9b734f&scoped=true"
import script from "./AboutProgram.vue?vue&type=script&lang=js"
export * from "./AboutProgram.vue?vue&type=script&lang=js"
import style0 from "./AboutProgram.vue?vue&type=style&index=0&id=1f9b734f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b734f",
  null
  
)

export default component.exports